import { render, staticRenderFns } from "./EventCalendarPanel.vue?vue&type=template&id=66434b67&"
import script from "./EventCalendarPanel.vue?vue&type=script&lang=js&"
export * from "./EventCalendarPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports